// extracted by css-extract-rspack-plugin
export default {"p":"p-EKcj0n","szyxy-low-code-tab":"szyxy-low-code-tab-AYc3s3","szyxyLowCodeTab":"szyxy-low-code-tab-AYc3s3"};